import * as z from "zod";

export interface IntegrationSettings {
  fields: z.ZodType;
  connect: z.ZodType;
  update: z.ZodType;
  read: z.ZodType;
  writeKeys: string[];
  readKeys: string[];
  secretKeys: string[];
  connectOnlyKeys: string[];
}

/** Secrets read back only as last-four `secretPreviews`; connectOnly never. */
export function defineIntegrationSettings<
  Fields extends z.ZodRawShape,
  Secrets extends z.ZodRawShape,
  ConnectOnly extends z.ZodRawShape,
  Computed extends z.ZodRawShape,
>(buckets: {
  fields: Fields;
  secrets: Secrets;
  connectOnly: ConnectOnly;
  computed: Computed;
}) {
  const fields = z.object(buckets.fields);
  const writable = fields.extend(buckets.secrets);
  const connect = writable.extend(buckets.connectOnly);
  const read = z
    .object(buckets.fields)
    .extend(buckets.computed)
    .extend({ secretPreviews: z.record(z.string(), z.string()) });
  return {
    fields,
    connect,
    update: writable.partial(),
    read,
    writeKeys: Object.keys(connect.shape),
    readKeys: Object.keys(read.shape),
    secretKeys: Object.keys(buckets.secrets),
    connectOnlyKeys: Object.keys(buckets.connectOnly),
  };
}
